import React from 'react';
import { ErrorMessage, IconType, RotatingIcon } from 'ui-toolkit/index';
import { CoverOnTop } from '../CoverOnTop';
import { IFormStatusWrapperProps } from '../../order/contacts/interfaces/IFormStatusWrapperProps';
import { SuccessMessage } from '../SuccessMessage';
import { DuplicateContactMessage } from '../../order/contacts/subComponents/DuplicateContactMessage';

interface IAddFormStatusWrapperProps extends IFormStatusWrapperProps {
  fetchedSuccess: boolean;
  successMessage: string | React.ReactNode;
  duplicateMessage?: string;
  onOkClick?: () => void;
}

export const FormStatusWrapper: React.FC<IAddFormStatusWrapperProps> = ({
  fetchError,
  fetching,
  fetchedSuccess,
  successMessage,
  duplicateMessage,
  onOkClick,
}) => {
  const isConflict = !!fetchError && fetchError.message === 'Request failed with status code 409';
  return (
    <>
      {fetching && (
        <CoverOnTop>
          <RotatingIcon type={IconType.Loading} />
        </CoverOnTop>
      )}
      {fetchedSuccess && (
        <CoverOnTop>
          <SuccessMessage successMessage={successMessage} onOkClick={onOkClick} />
        </CoverOnTop>
      )}
      {isConflict && (
        <CoverOnTop>
          <DuplicateContactMessage duplicateMessage={duplicateMessage} />
        </CoverOnTop>
      )}
      {fetchError && !isConflict && <ErrorMessage error={fetchError} />}
    </>
  );
};
